import api from './api.js';

class Manufacturers {
    constructor(){
        this.url_manufacturers = 'Manufacturers'
        this.url_smartCatalogManufacturers = 'SmartCatalogManufacturers'
        // this.url_defaultManufacturers = 'DefaultManufacturers'
    }
    get(id){
        return api.get(`${this.url_manufacturers}/${id}`);
    }
    getSmartCatalogManufacturer(id){
        return api.get(`${this.url_smartCatalogManufacturers}/${id}`);
    }
    all(){
        return api.get(`${this.url_manufacturers}/`);
    }
    // allSmartCatalog(){
    //     return api.get(`${this.url_smartCatalogManufacturers}/`);
    // }
    getDataSource(id){
        return api.getDataSource(this.url_manufacturers, id);
    }
    getDataSourceSmartCatManufacturers(id){
        return api.getDataSource(this.url_smartCatalogManufacturers, id);
    }
    // getDataSourceDefaultManufacturers(id){
    //     return api.getDataSource(this.url_defaultManufacturers, id);
    // }
    update(data){
        return api.put(`${this.url_manufacturers}/${data.id}`, data);
    }
    updateSmartCatalogManufacturer(data){
        return api.put(`${this.url_smartCatalogManufacturers}/${data.id}`, data);
    }

    getCatalog(id){
        return api.get(`${this.url_manufacturers}/${id}/CatalogHtml`);
    }

    getSmartCat(id){
        return api.get(`${this.url_manufacturers}/${id}/SmartCatalog`);
    }

    uploadCatalog(id, file){
        let headers = { 'Content-Type': 'multipart/form-data'};
        let formData = new FormData();
        formData.append('file',file,file.name);
        return api.post(`${this.url_manufacturers}/${id}/SmartCatalogZip`, formData, headers);
    }
}

export default new Manufacturers;
